module.exports = __webpack_public_path__ + "static/media/batteryGreen.18217654.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/DevicesList/batteryGreen.svg
// module id = 160
// module chunks = 0